import { render, staticRenderFns } from "./MallVoucherList.vue?vue&type=template&id=fe561002&scoped=true"
import script from "./MallVoucherList.vue?vue&type=script&lang=js"
export * from "./MallVoucherList.vue?vue&type=script&lang=js"
import style0 from "./MallVoucherList.vue?vue&type=style&index=0&id=fe561002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe561002",
  null
  
)

export default component.exports